import { mstOrderItem } from '@libs/enums';
import {
  Accordion,
  FieldSet,
  OutputKeyField,
  orderToDisplayWithPrefix,
  titleName,
  useItemNames,
  useSummaryGenerator,
} from '@ps-smart-cp/ppfw-client';
import { useState } from 'react';
import { outputOrderFieldConfig } from '../item-config';
import type { OutputOrder } from '../models';

interface Props {
  outputKey: OutputOrder;
  setOutputKey: (t: OutputOrder) => void;
}

export function OutputOrderField({ outputKey, setOutputKey }: Props) {
  const getTitleName = useItemNames(titleName);
  const generator = useSummaryGenerator();
  const createSummary = (o: OutputOrder) => () =>
    generator
      .with<OutputOrder>(o, outputOrderFieldConfig, {
        outputKey: { orderItem: mstOrderItem.toDisplayWithPrefix, order: orderToDisplayWithPrefix },
      })
      .generate();
  const [summary, setSummary] = useState(createSummary(outputKey));

  return (
    <FieldSet>
      <Accordion
        summary={summary}
        title={getTitleName('outputOrder')}
        onClose={() => setSummary(createSummary(outputKey))}
      >
        <OutputKeyField
          obj={outputKey}
          setObj={setOutputKey}
          prop="outputKey"
          items={outputOrderFieldConfig}
          enumType={mstOrderItem.enum}
          enumNameConfig={mstOrderItem.nameConfig}
          isLabelVisible
        />
      </Accordion>
    </FieldSet>
  );
}
